import{a as n}from"./chunk-ANXBDSUI.js";import{a as e}from"./chunk-WIMGWYZL.js";function T(...a){return e(l,a,y)}var l=(a,r)=>a.filter(r),y=a=>(r,t,o)=>a(r,t,o)?{done:!1,hasNext:!0,next:r}:n;export{T as a};
